import classnames from "classnames";
import React from "react";
import { vehicleTypes } from "../../../constants/vehicleTypes";
import { financeNumberFormat } from "../../../utils/formatters";
import { ReactComponent as Bag } from "./icons/luggage-icon.svg";
import { ReactComponent as Pax } from "./icons/passengers.svg";
import Loader from "../../Loader/Loader";
import SelectedVehicleCard from "./SelectedVehicleCard";
import styles from "./style.module.css";
import VehicleImage from "../../VehicleImage/VehicleImage";

export default function VehicleTypeField({ minPax = 0, minBags = 0, ...props }) {
  const availableOptions = React.useMemo(() => {
    const options = [ ...props.options.filter(x => x.pax >= minPax && x.bags >= minBags) ];
    options.sort((a, b) => vehicleTypes[a?.vehicleType] - vehicleTypes[b?.vehicleType]);
    return options;
  }, [ props.options, minPax, minBags ]);

  React.useEffect(() => {
    if (!props.value) {
      const data = availableOptions?.find?.(x => x);
      props.onChange(data);
    }
  }, [ availableOptions, props.value ]);

  React.useEffect(() => {
    if (!!props.value && !!availableOptions) {
      const data = availableOptions.find((item) => item.vehicleType === props.value.vehicleType);
      if (!!data) {
        props.onChange(data);
      } else {
        props.onChange(availableOptions[0]);
      }
    }

  }, [ availableOptions ]);

  if (props.isFetching) {
    return <Loader className={styles.loader} />;

  }
  return (
    <div className={classnames(styles.container, props.className)}>
      {props.value && <SelectedVehicleCard className={styles.selectedVehicle} vehicle={props.value} />}
      <nav className={styles.list} onMouseEnter={props.onFocus} onMouseLeave={props.onBlur}>
        {
          availableOptions?.map?.((item, index) =>
            <div
              key={item.vehicleType + index}
              onClick={() => props.onChange(item)}
              className={classnames(styles.item, {
                [styles.selected]: props.value.vehicleType === item.vehicleType,
              })}
            >
              <VehicleImage vehicleType={item.vehicleType} className={styles.vehicleLogo} />
              <span className={styles.title}>{item.vehicleTypeLabel}</span>

              <span className={styles.iconsContainer}>
                <span className={styles.iconContainer}>
                  <Pax className={styles.svg} />
                  <span className={styles.iconText}>{item.pax}</span>
                </span>
                <span className={styles.iconContainer}>
                  <Bag className={styles.svg} />
                  <span className={styles.iconText}>{item.bags}</span>
                </span>
              </span>

              <span className={styles.fare}>
                {`$${financeNumberFormat(item?.fare?.baseRate || 0)}`}
              </span>
            </div>,
          )
        }
      </nav>
    </div>
  );
}
